import { MoreHoriz, MoreVert } from "@material-ui/icons";

import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./ScrollMenu.module.scss";

interface IProps {
  category: any;
  handleCategoryFilter: (category: any) => void;
  handleSearch: (search: any) => void;
  loading: boolean;
}

const ScrollMenu: React.FC<IProps> = ({
  category,
  handleCategoryFilter,
  loading,
  handleSearch,
}) => {
  const [selected, setselected] = useState(0);
  const [view, setview] = useState(category);
  const [dropdown, setdropdown] = useState(category);
  //console.log(view);
  //console.log(dropdown);

  const [width, height] = useWindowSize();
  // console.log(width, height);

  const handleNavigation = () => {
    if (width > 1400) {
      setview(category.slice(0, 8));
      setdropdown(category.slice(8, category.length));
    } else if (width > 1200) {
      // console.log("disp;ay 5");
      setview(category.slice(0, 5));
      setdropdown(category.slice(5, category.length));
    } else if (width > 1000) {
      // console.log("display 4");
      setview(category.slice(0, 4));
      setdropdown(category.slice(4, category.length));
    } else if (width > 800) {
      // console.log("display 3");
      setview(category.slice(0, 3));
      setdropdown(category.slice(3, category.length));
    } else if (width > 600) {
      // console.log("display 2");
      setview(category.slice(0, 2));
      setdropdown(category.slice(2, category.length));
    } else {
      // console.log("display 1");
      setview(category.slice(0, 1));
      setdropdown(category.slice(1, category.length));
    }
  };

  useEffect(() => {
    handleNavigation();
  }, [width]);

  return (
    <div className={styles.nav_bar}>
      <div className={styles.categoty_list}>
        {/* <div className={styles.categoty_item}>
         
        </div> */}

        {loading === false &&
          category?.map((item: string, index: any) => (
            <div className={styles.categoty_item} key={index}>
              <button
                value={item}
                onClick={(e) => {
                  setselected(index);
                  handleCategoryFilter(e);
                }}
                className={
                  selected === index
                    ? styles.item_selected
                    : styles.item_not_selected
                }
              >
                {item}
              </button>
            </div>
          ))}

        {/* {loading === false &&
          view?.map((item: string, index: any) => (
            <div className={styles.categoty_item} key={index}>
              <button
                value={item}
                onClick={(e) => {
                  setselected(index);
                  handleCategoryFilter(e);
                }}
                className={
                  selected === index
                    ? styles.item_selected
                    : styles.item_not_selected
                }
              >
                {item}
              </button>
            </div>
          ))} */}
      </div>

      {/* <div className={styles.dropdown}>
        <MoreVert />
        <div className={styles.dropdown_list}>
          {dropdown?.map((item: string, index: any) => (
            <button
              value={item}
              key={index}
              onClick={(e) => {
                setselected(-1);
                handleCategoryFilter(e);
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </div> */}
      <input type="text" onChange={(e) => handleSearch(e)} />
    </div>
  );
};

export default ScrollMenu;

function useWindowSize() {
  const [size, setsize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setsize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}
